import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  class: "icon-heart",
  viewBox: "0 0 20 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "m10 17.213-.406-.265c-.34-.223-8.344-5.512-8.344-10.28C1.25 3.274 3.66 1.5 6.042 1.5c1.522 0 2.948.71 3.957 1.938C11.005 2.213 12.433 1.5 13.96 1.5c2.38 0 4.791 1.775 4.791 5.167 0 4.77-8.004 10.058-8.344 10.281l-.406.265Z"
    }, null, -1)
  ]))]))
}
export default { render: render }